// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating Project records.
 * @typedef {object} ProjectWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string | null} [name] - Value for the name attribute.
 * @property {string | null} [state] - Value for the state attribute.
 * @property {string | null} [description] - Value for the description attribute.
 * @property {Date | string | null} [deadlineAt] - Value for the deadlineAt attribute.
 * @property {string | null} [organizationId] - Value for the organizationId attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 * @property {number | null} [routingEpoch] - Value for the routingEpoch attribute.
 * @property {boolean} [automationAssignable] - Value for the automationAssignable attribute.
 */

/** @augments {DatabaseRecord<ProjectWriteAttributes>} */
export default class ProjectBase extends DatabaseRecord {
  /** @returns {typeof import("../models/project.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/project.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string | null} */
  name() { return this.readAttribute("name") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setName(newValue) { return this._setColumnAttribute("name", newValue) }

  /** @returns {boolean} */
  hasName() { return this._hasAttribute(this.name()) }

  /** @returns {string | null} */
  state() { return this.readAttribute("state") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setState(newValue) { return this._setColumnAttribute("state", newValue) }

  /** @returns {boolean} */
  hasState() { return this._hasAttribute(this.state()) }

  /** @returns {string | null} */
  description() { return this.readAttribute("description") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setDescription(newValue) { return this._setColumnAttribute("description", newValue) }

  /** @returns {boolean} */
  hasDescription() { return this._hasAttribute(this.description()) }

  /** @returns {Date | null} */
  deadlineAt() { return this.readAttribute("deadlineAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setDeadlineAt(newValue) { return this._setColumnAttribute("deadlineAt", newValue) }

  /** @returns {boolean} */
  hasDeadlineAt() { return this._hasAttribute(this.deadlineAt()) }

  /** @returns {string | null} */
  organizationId() { return this.readAttribute("organizationId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setOrganizationId(newValue) { return this._setColumnAttribute("organizationId", newValue) }

  /** @returns {boolean} */
  hasOrganizationId() { return this._hasAttribute(this.organizationId()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /** @returns {number | null} */
  routingEpoch() { return this.readAttribute("routingEpoch") }

  /**
   * @param {number | null} newValue
   * @returns {void}
   */
  setRoutingEpoch(newValue) { return this._setColumnAttribute("routingEpoch", newValue) }

  /** @returns {boolean} */
  hasRoutingEpoch() { return this._hasAttribute(this.routingEpoch()) }

  /** @returns {boolean} */
  automationAssignable() { return this.readAttribute("automationAssignable") }

  /**
   * @param {boolean} newValue
   * @returns {void}
   */
  setAutomationAssignable(newValue) { return this._setColumnAttribute("automationAssignable", newValue) }

  /** @returns {boolean} */
  hasAutomationAssignable() { return this._hasAttribute(this.automationAssignable()) }
}
